<template>
  <div class="open-in-google-maps">
    <a class="leaflet-bar-part" :title="$gettext('Open view in Google Maps')" href="#" @click.prevent.stop="openInGoogleMaps" style="position: relative; left: 3px;">
      <img src="/static/img/gmaps.svg" alt="" style="width: 30px">
    </a>
  </div>
</template>

<script>
import MapService from '@/services/MapService'

export default {
  name: 'OpenInGoogleMaps',
  methods: {
    openInGoogleMaps() {
      const center = MapService.getCenter()
      const zoom = MapService.getZoom()

      window.open(`https://www.google.com/maps/@${center.lat},${center.lng},${zoom}z`)
    }
  }
}
</script>